import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {
    dateRange: [null, null],
    schoolDistrictId: "00000000-0000-0000-0000-000000000000",
    academicYearId: "",
    quickPreset: "schoolYear",
  },
  activeSection: "executive",
  alertRules: [],
  alertHistory: [],
  cohortDefinitions: [],
  cachedSparklines: {},
};

export const kpiCenterSlice = createSlice({
  name: "kpiCenter",
  initialState,
  reducers: {
    setKPIFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    setActiveSection(state, action) {
      state.activeSection = action.payload;
    },
    setDateRange(state, action) {
      state.filters.dateRange = action.payload;
    },
    setDistrict(state, action) {
      state.filters.schoolDistrictId = action.payload;
    },
    setAcademicYear(state, action) {
      state.filters.academicYearId = action.payload;
    },
    setQuickPreset(state, action) {
      state.filters.quickPreset = action.payload;
    },
    addAlertRule(state, action) {
      state.alertRules.push(action.payload);
    },
    removeAlertRule(state, action) {
      state.alertRules = state.alertRules.filter((r) => r.id !== action.payload);
    },
    updateAlertRule(state, action) {
      const idx = state.alertRules.findIndex((r) => r.id === action.payload.id);
      if (idx !== -1) state.alertRules[idx] = action.payload;
    },
    addAlertHistory(state, action) {
      state.alertHistory.unshift(action.payload);
      if (state.alertHistory.length > 100) state.alertHistory.pop();
    },
    clearAlertHistory(state) {
      state.alertHistory = [];
    },
    addCohort(state, action) {
      state.cohortDefinitions.push(action.payload);
    },
    removeCohort(state, action) {
      state.cohortDefinitions = state.cohortDefinitions.filter(
        (c) => c.id !== action.payload
      );
    },
    cacheSparkline(state, action) {
      const { key, data } = action.payload;
      state.cachedSparklines[key] = data;
    },
    resetKPICenter: () => initialState,
  },
});

export const {
  setKPIFilters,
  setActiveSection,
  setDateRange,
  setDistrict,
  setAcademicYear,
  setQuickPreset,
  addAlertRule,
  removeAlertRule,
  updateAlertRule,
  addAlertHistory,
  clearAlertHistory,
  addCohort,
  removeCohort,
  cacheSparkline,
  resetKPICenter,
} = kpiCenterSlice.actions;

export default kpiCenterSlice.reducer;
